import customContent from '@/services/api/customContent';

export default {
    namespaced: true,
    state: {
        customContent: null
    },
    getters: {
        getCustomContent: (state) => state.customContent
    },
    mutations: {
        setCustomContent (state, data) {
            state.customContent = data;
        }
    },
    actions: {
        getCustomContent (context, file) {
            return customContent.getCustomContent().then((data) => {
                context.commit('setCustomContent', data.data);
            });
        }
    }
};
